import React, { useEffect, useState, Suspense, lazy } from 'react';
import { CountdownTimer } from './components/CountdownTimer';
import { HeroSection } from './components/HeroSection';
// Lazy load everything below the fold
const ProblemSection = lazy(() => import('./components/ProblemSection').then(m => ({
  default: m.ProblemSection
})));
const TruthSection = lazy(() => import('./components/TruthSection').then(m => ({
  default: m.TruthSection
})));
const SolutionSection = lazy(() => import('./components/SolutionSection').then(m => ({
  default: m.SolutionSection
})));
const WhatItIsNot = lazy(() => import('./components/WhatItIsNot').then(m => ({
  default: m.WhatItIsNot
})));
const HowItWorks = lazy(() => import('./components/HowItWorks').then(m => ({
  default: m.HowItWorks
})));
const TomosSection = lazy(() => import('./components/TomosSection').then(m => ({
  default: m.TomosSection
})));
const BonusSection = lazy(() => import('./components/BonusSection').then(m => ({
  default: m.BonusSection
})));
const TestimonialsSection = lazy(() => import('./components/TestimonialsSection').then(m => ({
  default: m.TestimonialsSection
})));
const PricingSection = lazy(() => import('./components/PricingSection').then(m => ({
  default: m.PricingSection
})));
const GuaranteeSection = lazy(() => import('./components/GuaranteeSection').then(m => ({
  default: m.GuaranteeSection
})));
const FinalCTA = lazy(() => import('./components/FinalCTA').then(m => ({
  default: m.FinalCTA
})));
const Footer = lazy(() => import('./components/Footer').then(m => ({
  default: m.Footer
})));
const PurchasePopup = lazy(() => import('./components/PurchasePopup').then(m => ({
  default: m.PurchasePopup
})));
const MetaPixel = lazy(() => import('./components/MetaPixel').then(m => ({
  default: m.MetaPixel
})));
function DeferredPixel() {
  const [ready, setReady] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setReady(true), 2500);
    return () => clearTimeout(t);
  }, []);
  if (!ready) return null;
  return <Suspense fallback={null} data-id="element-0">
      <MetaPixel data-id="element-1" />
    </Suspense>;
}
export function App() {
  return <div className="min-h-screen bg-white font-['Open_Sans'] selection:bg-yellow-300 selection:text-black" data-id="element-2">
      <DeferredPixel data-id="element-3" />
      <CountdownTimer data-id="element-4" />

      <main data-id="element-5">
        <HeroSection data-id="element-6" />
        <Suspense fallback={<div className="min-h-[200px]" data-id="element-8" />} data-id="element-7">
          <ProblemSection data-id="element-9" />
          <TruthSection data-id="element-10" />
          <SolutionSection data-id="element-11" />
          <WhatItIsNot data-id="element-12" />
          <HowItWorks data-id="element-13" />
          <TomosSection data-id="element-14" />
          <BonusSection data-id="element-15" />
          <TestimonialsSection data-id="element-16" />
          <PricingSection data-id="element-17" />
          <GuaranteeSection data-id="element-18" />
          <FinalCTA data-id="element-19" />
        </Suspense>
      </main>

      <Suspense fallback={null} data-id="element-20">
        <Footer data-id="element-21" />
        <PurchasePopup data-id="element-22" />
      </Suspense>
    </div>;
}